import { render, staticRenderFns } from "./login3.vue?vue&type=template&id=2f2c7cfa&scoped=true"
import script from "./login3.vue?vue&type=script&lang=js"
export * from "./login3.vue?vue&type=script&lang=js"
import style0 from "./login3.vue?vue&type=style&index=0&id=2f2c7cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c7cfa",
  null
  
)

export default component.exports